import { createContext } from "react"

const ClientContext: any  = createContext<any>(null)

export default ClientContext
